import React, { InputHTMLAttributes } from "react";
import { FormError } from "@3gaam/shared/types/error";

type Props = InputHTMLAttributes<HTMLTextAreaElement> & {
  rows?: number;
  cols?: number;
  error?: FormError;
};

const TextAreaField = ({
  onChange,
  name,
  value,
  placeholder,
  className,
  rows,
  cols,
  error,
}: Props) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div className={`inp-box ${showError ? "invalid-field" : ""}`}>
        <textarea
          className={`form-control ${className}`}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          cols={cols || 30}
          rows={rows || 5}
        ></textarea>
      </div>
      {showError && name && (
        <p className="text-red font-12 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

export default TextAreaField;
